const t = {}, i = (e) => {
  if (t[e]) return t[e];
  if (e.startsWith("var(--"))
    return t[e] = e, e;
  let n = "";
  return e.startsWith("--hsds-") || (n = "--hsds-"), e.includes("token-") || (n += "token-"), n += `${e.replaceAll(".", "-")}`, n = `var(${n})`, t[e] = n, n;
};
export {
  i as getToken
};
